import type { RouteObject } from 'react-router-dom';
import LoginPage from '../pages/login/page';
import VacancySelectionPage from '../pages/vacancy-selection/page';
import HRManagerPage from '../pages/hr-manager/page';
import ChatOperatorPage from '../pages/chat-operator/page';
import SmmManagerPage from '../pages/smm-manager/page';
import QualityManagerPage from '../pages/quality-manager/page';
import OnlineManagerPage from '../pages/online-manager/page';
import MeetingPage from '../pages/meeting/page';
import NotFound from '../pages/NotFound';
import { RequireAuth, RequireVacancy, RequireMeetingAccess } from './RequireVacancy';

const routes: RouteObject[] = [
  { path: '/', element: <LoginPage /> },
  { path: '/vacancy', element: <RequireAuth><VacancySelectionPage /></RequireAuth> },
  { path: '/hr-manager', element: <RequireVacancy vacancy="hr-manager"><HRManagerPage /></RequireVacancy> },
  { path: '/chat-operator', element: <RequireVacancy vacancy="chat-operator"><ChatOperatorPage /></RequireVacancy> },
  { path: '/smm-manager', element: <RequireVacancy vacancy="smm-manager"><SmmManagerPage /></RequireVacancy> },
  { path: '/quality-manager', element: <RequireVacancy vacancy="quality-manager"><QualityManagerPage /></RequireVacancy> },
  { path: '/online-manager', element: <RequireVacancy vacancy="online-manager"><OnlineManagerPage /></RequireVacancy> },
  { path: '/meeting', element: <RequireMeetingAccess><MeetingPage /></RequireMeetingAccess> },
  { path: '*', element: <NotFound /> },
];

export default routes;
